import React, {useEffect, useRef, useState} from 'react';
import {Map, MapMarker, Polygon} from 'react-kakao-maps-sdk';
import {markerdata} from './data';
import {flagimg} from '../../../config/images';
import {CourseTitle} from './style';
import * as S from './style';

const MapCourseFive = ({lat = 34.93342, lng = 127.51992}) => {
	const [map, setMap] = useState(null);

	useEffect(() => {
		const {kakao} = window;
		const mapContainer = document.getElementById('mapfive'); // 지도를 표시한 곳
		const location = new kakao.maps.LatLng(lat, lng);

		const mapOptions = {
			// 지도의 옵션
			center: location, //지도의 중심좌표.
			level: 5, //지도의 레벨(확대, 축소 정도)
		};

		//지도 생성
		const kakaoMap = new kakao.maps.Map(mapContainer, mapOptions);

		//마커 이미지
		const myMarker = flagimg,
			myMarkerSize = new window.kakao.maps.Size(30, 30),
			myMarkerOption = {offset: new window.kakao.maps.Point(4, 30)};

		const myMarkerPosition = new window.kakao.maps.MarkerImage(
			myMarker,
			myMarkerSize,
			myMarkerOption,
		);

		//마커 여러개 표시
		markerdata.forEach((el, i) => {
			//출발, 도착 깃발 마커
			if (i == 0) {
				var marker = new kakao.maps.Marker({
					map: kakaoMap,
					position: new kakao.maps.LatLng(el.lat, el.lng),
					image: myMarkerPosition,
				});
				marker.setMap(kakaoMap);
			} else {
				//일반 반환마커
				var originmarker = new kakao.maps.Marker({
					map: kakaoMap,
					position: new kakao.maps.LatLng(el.lat, el.lng),
				});
				originmarker.setMap(kakaoMap);
			}
			var customOverlay = new kakao.maps.CustomOverlay({
				position: new kakao.maps.LatLng(el.lat, el.lng),
				content: `<div class ="label" style="margin: -55px auto;"><span class="left"></span><span class="center" style="color: black; background-color: white; border-radius: 7px; padding: 1px 10px;  border: solid 1px #d9d9d9;
">${el.title}</span><span class="right"></span></div></div>`,
			});

			customOverlay.setMap(kakaoMap);
		});

		//컨트롤 표시
		var mapTypeControl = new kakao.maps.MapTypeControl();
		kakaoMap.addControl(
			mapTypeControl,
			kakao.maps.ControlPosition.TOPRIGHT,
		);

		// 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
		var zoomControl = new kakao.maps.ZoomControl();
		kakaoMap.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

		//지도 범위 핀 다 보이게 재설정

		//폴리 라인 그리기
		const linePath = [
			new kakao.maps.LatLng(34.93824533293566, 127.51941208098545), //팔마종합운동장
			new kakao.maps.LatLng(34.937598321503366, 127.51894827556737),
			new kakao.maps.LatLng(34.93688601670695, 127.51899851768951),
			new kakao.maps.LatLng(34.93484871855129, 127.51904041201075),
			new kakao.maps.LatLng(34.93469, 127.51906),
			new kakao.maps.LatLng(34.93457, 127.5197),

			new kakao.maps.LatLng(34.93448889217353, 127.51992472670887), 
			new kakao.maps.LatLng(34.93417238688551, 127.5201635284935),
			new kakao.maps.LatLng(34.93402349912809, 127.52020089743351),
			new kakao.maps.LatLng(34.933852382067116, 127.52016698102369),
			new kakao.maps.LatLng(34.933690887606886, 127.51999083604403),
			new kakao.maps.LatLng(34.93339129764623, 127.51943620761327),  // 사거리
			new kakao.maps.LatLng(34.93205301270009, 127.51407560420807),
			new kakao.maps.LatLng(34.927467253069906, 127.51566678783557),

			new kakao.maps.LatLng(34.92798799580195, 127.51615160792059),
			new kakao.maps.LatLng(34.928829079492566, 127.51761252052867),
			new kakao.maps.LatLng(34.929800, 127.521744),
			new kakao.maps.LatLng(34.929609, 127.522275),
			new kakao.maps.LatLng(34.929620, 127.522699),

			new kakao.maps.LatLng(34.929589, 127.523026),
			new kakao.maps.LatLng(34.929285, 127.521883),
		];

		var polyline = new kakao.maps.Polyline({
			path: linePath,
			strokeWeight: 5,
			strokeColor: '#005bac',
			strokeOpacity: 1,
			strokeStyle: 'solid',
		});

		polyline.setMap(kakaoMap);
	}, []);

	return (
		<>
			<CourseTitle>5km</CourseTitle>
			<div
				id='mapfive'
				style={{
					width: '100%',
					height: '650px',
				}}
			></div>
		</>
	);
};

export default MapCourseFive;
